import { LicenseType } from '@ebalance/proto/bfftypes/v1/license_type_pb'

/**
 * 業務ワークフローの BG コード欄に入るコードの種別 (spec AC-WFW-003j / AC-WFW-001)。
 * `generation` は BG コードではなく発電の計画提出者コード (BG マスタの発電 BG とは別物)。
 */
export type WorkflowTargetCodeKind =
  | 'demandBg'
  | 'selfWheelingBg'
  | 'generation'

/** 作成ダイアログの候補の並び (design `demand/cases.html` `_LICENSE_RANK`)。 */
export const WORKFLOW_TARGET_CODE_KIND_RANK: Record<
  WorkflowTargetCodeKind,
  number
> = {
  demandBg: 0,
  selfWheelingBg: 1,
  generation: 2,
}

/**
 * BG マスタの License から種別を引く。業務ワークフローの BG コードに選べない
 * License (発電 BG・需要抑制 BG 等) は undefined。
 */
export function workflowTargetCodeKindOfBgLicense(
  licenseType: LicenseType,
): WorkflowTargetCodeKind | undefined {
  switch (licenseType) {
    case LicenseType.RETAIL:
      return 'demandBg'
    case LicenseType.SELF_WHEELING:
      return 'selfWheelingBg'
    default:
      return undefined
  }
}

const LABEL_KEY: Record<WorkflowTargetCodeKind, string> = {
  demandBg: 'page:workflowCases.form.bgCodeKind.demandBg',
  selfWheelingBg: 'page:workflowCases.form.bgCodeKind.selfWheelingBg',
  generation: 'page:workflowCases.form.bgCodeKind.generation',
}

/** 作成ダイアログの候補に添える種別 (需要 BG / 自己託送 BG / 発電) の i18n key。 */
export function workflowTargetCodeKindLabelKey(
  kind: WorkflowTargetCodeKind,
): string {
  return LABEL_KEY[kind]
}
